export const CatalogAdminTranslations = {
  en: {
    catalog: {
      title: "Catalog",
      resources: {
        chillers: "Chillers",
        compressors: "Compressors",
        systems: "Systems",
        voltages: "Voltages",
        technologies: "Technologies",
        refrigerants: "Refrigerants",
        "heat-exchangers": "Heat exchangers",
        efficiencies: "Efficiencies",
        locations: "Locations",
      },
      fields: {
        name: "Name",
        type: "Type",
        system_name: "System name",
        code: "Code",
        volts: "Volts",
        phase: "Phase",
        frequency: "Frequency",
        approach_type: "Approach type",
        city: "City",
        latitude: "Latitude",
        longitude: "Longitude",
        amsl: "Altitude",
        pressure_millibar: "Pressure",
        average_temperature_celsius: "Average temperature",
        dry_bulb_celsius: "Dry bulb",
        wet_bulb_celsius: "Wet bulb",
        model: "Model",
        refrigerant: "Refrigerant",
        lra: "LRA",
        rla: "RLA",
        rt_c: "Capacity curve (rt_c)",
        rt_w: "Power curve (rt_w)",
        rt_a: "Current curve (rt_a)",
        rt_m: "Curve rt_m",
        nominal_capacity: "Nominal capacity",
        size: "Size",
        system_id: "System",
        refrigerant_id: "Refrigerant",
        voltage_id: "Voltage",
        technology_id: "Technology",
        heat_exchanger_id: "Heat exchanger",
        efficiency_id: "Efficiency",
        compressor_motor_type: "Compressor motor type",
        condenser_type: "Condenser type",
        fan_motor_type: "Fan motor type",
        coil_type: "Coil type",
        condensing_approach: "Condensing approach",
        heat_exchanger_approach: "Heat exchanger approach",
        inverter: "Inverter",
      },
      list: {
        search: "Search",
        new: "New",
        import: "Import CSV",
        edit: "Edit",
        delete: "Delete",
        empty: "Nothing here yet.",
        previous: "Previous",
        next: "Next",
        page: "Page {{page}} of {{pages}} · {{total}} records",
      },
      form: {
        newTitle: "New · {{resource}}",
        editTitle: "Edit · {{resource}}",
        save: "Save",
        cancel: "Cancel",
        none: "—",
        integersHint: "Whole numbers separated by commas: 220, 440",
        integersOnly: "Whole numbers only, separated by commas.",
      },
      compressor: {
        normalized: "It will be saved as {{model}}: the server removes spaces.",
        hint: "Paste the 10 coefficients from the datasheet, separated by spaces, commas, semicolons, tabs or line breaks. Use a decimal point.",
        count: "{{n}} / {{total}}",
        invalid: "Not numbers: {{values}}",
      },
      chiller: {
        newTitle: "New chiller",
        editTitle: "Edit chiller",
        back: "Back to the list",
        general: "General data",
        references: "References",
        circuits: "Circuits",
        circuit: "Circuit {{number}}",
        addCircuit: "Add circuit",
        removeCircuit: "Remove circuit",
        compressors: "Compressors",
        compressorLabel: "Compressor {{number}} of circuit {{circuit}}",
        addCompressor: "Add compressor",
        removeCompressor: "Remove compressor {{number}} of circuit {{circuit}}",
        condensers: "Condensers",
        fans: "Fans",
        coils: "Coils",
        evaporator: "Evaporator",
        componentOf: "{{component}} of circuit {{circuit}}",
        quantityOf: "{{component}} quantity of circuit {{circuit}}",
        evaporatorOf: "Evaporator of circuit {{circuit}}",
        quantity: "Qty.",
        notInCatalog: "(not in the catalog)",
        centrifugalNote:
          "The engine asks the selector for a centrifugal's compressors; they are not looked up in the catalog.",
        missing:
          "This chiller cites compressors that are not in the catalog: {{models}}. It cannot be saved until they are added. Today its performance sheet fails with CompressorNotFound.",
        createCompressor: "Add {{model}}",
        totals: "Totals",
        totalCompressors: "Compressors",
        totalCondensers: "Condensers",
        totalFans: "Fans",
        totalEvaporators: "Evaporators",
        totalsNote: "The server calculates them when saving.",
      },
      delete: {
        title: "Delete {{name}}?",
        body: "This cannot be undone.",
        confirm: "Yes, delete",
      },
      import: {
        title: "Import CSV · {{resource}}",
        note: "Only new records. If one row fails, none is imported.",
        chillersNote: "circuits goes as JSON inside the cell.",
        downloadHeader: "Download header",
        file: "CSV file",
        submit: "Import",
        created: "{{n}} records created",
      },
      forbidden: {
        title: "No access to the catalog",
        body: "Your session does not have permission to manage the catalog. If you were just given it, sign out and sign in again.",
        signOut: "Sign out",
      },
      errors: {
        generic: "The operation could not be completed. Try again.",
      },
    },
  },
  es: {
    catalog: {
      title: "Catálogo",
      resources: {
        chillers: "Chillers",
        compressors: "Compresores",
        systems: "Sistemas",
        voltages: "Voltajes",
        technologies: "Tecnologías",
        refrigerants: "Refrigerantes",
        "heat-exchangers": "Intercambiadores",
        efficiencies: "Eficiencias",
        locations: "Ubicaciones",
      },
      fields: {
        name: "Nombre",
        type: "Tipo",
        system_name: "Nombre del sistema",
        code: "Código",
        volts: "Voltios",
        phase: "Fases",
        frequency: "Frecuencia",
        approach_type: "Tipo de approach",
        city: "Ciudad",
        latitude: "Latitud",
        longitude: "Longitud",
        amsl: "Altitud",
        pressure_millibar: "Presión",
        average_temperature_celsius: "Temperatura media",
        dry_bulb_celsius: "Bulbo seco",
        wet_bulb_celsius: "Bulbo húmedo",
        model: "Modelo",
        refrigerant: "Refrigerante",
        lra: "LRA",
        rla: "RLA",
        rt_c: "Curva de capacidad (rt_c)",
        rt_w: "Curva de potencia (rt_w)",
        rt_a: "Curva de corriente (rt_a)",
        rt_m: "Curva rt_m",
        nominal_capacity: "Capacidad nominal",
        size: "Tamaño",
        system_id: "Sistema",
        refrigerant_id: "Refrigerante",
        voltage_id: "Voltaje",
        technology_id: "Tecnología",
        heat_exchanger_id: "Intercambiador",
        efficiency_id: "Eficiencia",
        compressor_motor_type: "Tipo de motor del compresor",
        condenser_type: "Tipo de condensador",
        fan_motor_type: "Tipo de motor del ventilador",
        coil_type: "Tipo de serpentín",
        condensing_approach: "Approach de condensación",
        heat_exchanger_approach: "Approach del intercambiador",
        inverter: "Inverter",
      },
      list: {
        search: "Buscar",
        new: "Nuevo",
        import: "Importar CSV",
        edit: "Editar",
        delete: "Borrar",
        empty: "Todavía no hay nada.",
        previous: "Anterior",
        next: "Siguiente",
        page: "Página {{page}} de {{pages}} · {{total}} registros",
      },
      form: {
        newTitle: "Nuevo · {{resource}}",
        editTitle: "Editar · {{resource}}",
        save: "Guardar",
        cancel: "Cancelar",
        none: "—",
        integersHint: "Números enteros separados por comas: 220, 440",
        integersOnly: "Solo números enteros, separados por comas.",
      },
      compressor: {
        normalized: "Se guardará como {{model}}: el servidor quita los espacios.",
        hint: "Pega los 10 coeficientes de la ficha, separados por espacio, coma, punto y coma, tabulador o salto de línea. Usa punto decimal.",
        count: "{{n}} / {{total}}",
        invalid: "No son números: {{values}}",
      },
      chiller: {
        newTitle: "Nuevo chiller",
        editTitle: "Editar chiller",
        back: "Volver a la lista",
        general: "Datos generales",
        references: "Referencias",
        circuits: "Circuitos",
        circuit: "Circuito {{number}}",
        addCircuit: "Añadir circuito",
        removeCircuit: "Quitar circuito",
        compressors: "Compresores",
        compressorLabel: "Compresor {{number}} del circuito {{circuit}}",
        addCompressor: "Añadir compresor",
        removeCompressor: "Quitar el compresor {{number}} del circuito {{circuit}}",
        condensers: "Condensadores",
        fans: "Ventiladores",
        coils: "Serpentines",
        evaporator: "Evaporador",
        componentOf: "{{component}} del circuito {{circuit}}",
        quantityOf: "Cantidad de {{component}} del circuito {{circuit}}",
        evaporatorOf: "Evaporador del circuito {{circuit}}",
        quantity: "Cant.",
        notInCatalog: "(no existe)",
        centrifugalNote:
          "El motor pide los compresores de un centrífugo al selector; no se buscan en el catálogo.",
        missing:
          "Este chiller cita compresores que no están en el catálogo: {{models}}. No se podrá guardar hasta darlos de alta. Hoy su hoja de performance falla con CompressorNotFound.",
        createCompressor: "Dar de alta {{model}}",
        totals: "Totales",
        totalCompressors: "Compresores",
        totalCondensers: "Condensadores",
        totalFans: "Ventiladores",
        totalEvaporators: "Evaporadores",
        totalsNote: "Los calcula el servidor al guardar.",
      },
      delete: {
        title: "¿Borrar {{name}}?",
        body: "No se puede deshacer.",
        confirm: "Sí, borrar",
      },
      import: {
        title: "Importar CSV · {{resource}}",
        note: "Solo altas. Si una fila falla, no se importa ninguna.",
        chillersNote: "circuits va como JSON dentro de la celda.",
        downloadHeader: "Descargar cabecera",
        file: "Archivo CSV",
        submit: "Importar",
        created: "Se crearon {{n}} registros",
      },
      forbidden: {
        title: "Sin acceso al catálogo",
        body: "Tu sesión no tiene permiso para administrar el catálogo. Si te lo acaban de dar, cierra sesión y vuelve a entrar.",
        signOut: "Cerrar sesión",
      },
      errors: {
        generic: "No se pudo completar la operación. Inténtalo de nuevo.",
      },
    },
  },
};
